import React, { FormEvent } from 'react';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import ErrorIcon from '@mui/icons-material/ErrorOutline'
import Button from '@mui/material/Button';

import Fetch from '../../script/Fetch';

import { Avatar, Card, Stack, TextField } from '@mui/material';
import { red } from '@mui/material/colors';
import { useAuth } from '../../auth/AuthContext';
import UserAuthenticated from '../../auth/UserAuthenticated';
import { Navigate } from 'react-router-dom-v5-compat';

interface Props { }

export const Login = (props: Props) => {
    const [email, setEmail] = React.useState<string>('');
    const [password, setPassword] = React.useState<string>('');
    const [error, setError] = React.useState<{ state: boolean, message: string }>({ state: false, message: '' });
    const [loading, setLoading] = React.useState<boolean>(false);

    let { isAuthenticated, login } = useAuth();

    if (isAuthenticated) {
        let ristoranteIdList = UserAuthenticated.getInstance().ristoranteIdList;
        if (ristoranteIdList.length === 0) {
            throw new Error("Non sono collegati ristoranti nell'utente");
        }

        return <Navigate to={`/bi/${ristoranteIdList[0]}`} />;
    }

    const onSubmit = async (e: FormEvent<HTMLFormElement> | undefined) => {
        e?.preventDefault();
        e?.stopPropagation();

        if (password === '' || email === '') {
            setError({ state: true, message: 'Riempi tutti i campi' });
            return;
        }

        setLoading(true);

        try {
            await Fetch.login(email, password);
            login();
        } catch (err: any) {
            console.log(err);
            let message: string;
            if (err.code === "auth/wrong-password") {
                message = "Password errata";
            } else if (err.code === "auth/too-many-requests") {
                message = "Troppe richieste, aspetta";
            } else if (err.code === "auth/invalid-email") {
                message = "Email non valida";
            } else if (err.code === "auth/user-not-found") {
                message = "Email o password errati";
            } else {
                message = "C'è stato un errore insolito. Contatta l'assistenza per maggiori informazioni";
            }

            setError({ state: true, message: message });
        } finally {
            setLoading(false);
        }
    };

    const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | undefined) => {
        if (event === undefined) {
            return;
        }

        const email = event.target.value;
        setEmail(email);
    }

    const onChangePassword = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | undefined) => {
        if (event === undefined) {
            return;
        }

        const password = event.target.value;
        setPassword(password);
    }

    const error_state = error.state;

    return (
        <Stack alignItems={"center"} sx={{ p: 4 }}>
            <Card variant="outlined" sx={{ borderRadius: 2, maxWidth: 662, width: "100%" }}>
                <Stack alignItems="center" sx={{
                    p: 4,
                    pb: 7,
                    gap: 3
                }}>
                    <Avatar>
                        <PersonIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5" align="center">Login</Typography>
                    <form
                        onSubmit={(e) => onSubmit(e)}
                        onInvalid={(e) => {
                            e.preventDefault();
                            onSubmit(undefined)
                        }}
                    >
                        <Stack sx={{
                            gap: 2,
                            width: 300,
                        }}>
                            <TextField
                                label={"Email"}
                                type={"text"}
                                error={error_state}
                                onChange={onChangeEmail}
                                required
                                autoComplete={"email"}
                                variant={"outlined"}
                                fullWidth
                            />
                            <TextField
                                label={"Password"}
                                type={"password"}
                                error={error_state}
                                onChange={onChangePassword}
                                required
                                autoComplete={"current-password"}
                                variant={"outlined"}
                                fullWidth
                            />
                            {
                                error.state && (
                                    <Stack color='error' sx={{
                                        color: red[500],
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: 1
                                    }}>
                                        <ErrorIcon fontSize="small" />
                                        <Typography align="justify" >
                                            {error.message}
                                        </Typography>
                                    </Stack>
                                )
                            }
                            <Button disabled={loading} style={{ width: "100%" }} type="submit" variant="contained">
                                Login
                            </Button>
                        </Stack>
                    </form>
                </Stack>
            </Card>
        </Stack>
    );
}